<template>

<div class="webdesigntuts-workshop">
	<form action="" method="">		    
		<input type="search" placeholder="What are you looking for?">		    	
		<button>Search</button>
	</form>
</div>

</template>

<style scoped>

.webdesigntuts-workshop {
	background: #;
	height: 100%;
    position: absolute;
    left: 32%;
    bottom: 187%;
	text-align: center;
	width: 100%;
}

.webdesigntuts-workshop:before,
.webdesigntuts-workshop:after {
	content: '';
	display: block;	
	height: 0px;
	margin: 0 0 0 -400px;
	position: absolute;
	width: 800px;
}

.webdesigntuts-workshop:before {
	/* background: #424242;
	background: linear-gradient(left, #151515, #444, #151515); */
	top: 192px;
}

.webdesigntuts-workshop:after {
	/* background: #000;
	background: linear-gradient(left, #151515, #000, #151515);	 */
	top: 191px;
}

.webdesigntuts-workshop form {

	border: 0px solid #000;
	border-radius: 5px;
	box-shadow: inset 0 0 0 0px #272727;
	display: inline-block;
	font-size: 0px;
	margin: 150px auto 0;
	padding: 20px;
	position: relative;
	z-index: 1;
}

.webdesigntuts-workshop input {
	/* background: #424242;	
	background: linear-gradient(#333, #222);	 */
	border: 1px solid #424242;
	border-radius: 5px 0 0 5px;
	box-shadow: 0 1px 0 #000;
	color: #888;
	display: block;
	float: left;
	font-family: 'Cabin', helvetica, arial, sans-serif;
	font-size: 13px;
	font-weight: 400;
	height: 40px;
	margin: 0;
	padding: 0 10px;
	text-shadow: 0 -1px 0 #000;
	width: 250px;
}

.ie .webdesigntuts-workshop input {
	line-height: 40px;
}

.webdesigntuts-workshop input::-webkit-input-placeholder {
   color: #888;
}

.webdesigntuts-workshop input:-moz-placeholder {
   color: #888;
}

.webdesigntuts-workshop input:focus {
	animation: glow 800ms ease-out infinite alternate;
	/* background: #424242;
	background: linear-gradient(#333933, #222922); */
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;
}

.webdesigntuts-workshop input:focus::-webkit-input-placeholder { 
	color: #efe;
}

.webdesigntuts-workshop input:focus:-moz-placeholder {
	color: #efe;
}

.webdesigntuts-workshop button {
	/* background: #222;
	background: linear-gradient(#333, #222); */
	box-sizing: border-box;
	border: 1px solid #424242;
	border-left-color: #000;
	border-radius: 0 5px 5px 0;
	box-shadow: 0 1px 0 #000;
	color: #fff;
	display: block;
	float: left;
	font-family: 'Cabin', helvetica, arial, sans-serif;
	font-size: 13px;
	font-weight: 400;
	height: 40px;
	line-height: 40px;
	margin: 0;
	padding: 0;
	position: relative;
	text-shadow: 0 -1px 0 #000;
	width: 80px;
}	

.webdesigntuts-workshop button:hover,
.webdesigntuts-workshop button:focus {
	background: #292929;
	background: linear-gradient(#424242, #414141);
	color: #5f5;
	outline: none;
}

.webdesigntuts-workshop button:active {
	background: #292929;
	background: linear-gradient(#393939, #292929);
	box-shadow: 0 0px 0 #000, inset 1px 0 1px #222;
	top: 1px;
}

@keyframes glow {
    0% {
		border-color: #393;
		box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(120,166,156,.1), 0 2px 0 #000;
    }	
    100% {
		border-color: #78b59c;
		box-shadow: 0 0 8px rgba(0,255,0,.8), inset 0 0 10px rgba(120,166,156,.4), 0 2px 0 #000;
    }
}

</style>

<script>
export default {
    
}
</script>